<template>
  <a-modal
    v-model="visible"
    :afterClose="resetModal"
    :keyboard="false"
    :maskClosable="false"
    :closable="false"
  >
    <a-form-model
      ref="tempPassConfirm"
      :model="confirmAddSupport"
      :rules="rules"
      class="pt-4"
    >
      <a-form-model-item prop="password">
        <a-input-password
          class="mb-2 mt-2"
          size="large"
          v-model="confirmAddSupport.password"
          placeholder="temporary Passowrd"
          v-on:keyup.enter="ok"
        >
          <a-icon slot="prefix" type="lock" class="input-icon" />
        </a-input-password>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button
        type="primary"
        @click="ok"
        :loading="loading"
        :disabled="!formIsValid"
        >Check</a-button
      >
      <a-button @click="cancel">{{ isClosable ? "Close" : "Back" }}</a-button>
    </template>
  </a-modal>
</template>
<script>
import { usersMutations } from "../../Store/store.js";

export default {
  props: {
    value: Boolean,
    loading: Boolean,
    Closable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirmAddSupport: {
        password: "",
        companyName: "",
      },
      rules: {
        password: [
          {
            required: true,
            message: "Please input your Temporary Password",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    formIsValid: function () {
      return this.confirmAddSupport.password !== "";
    },
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isClosable:{
      get(){
        return this.Closable;
      }
    }
  },

  methods: {
    cancel() {
      if (this.isClosable) {
        this.$emit("close");
      } else {
        this.$router.push({ name: this.$landingPage });
      }
    },
    async ok() {
      this.$refs.tempPassConfirm.validate(async (valid) => {
        if (valid) {
          var isValid = await usersMutations.checkTempPassword(
            this.confirmAddSupport
          );
          if (!isValid.data)
            this.$message.error("The temporary password is wrong!");
          else this.$emit("confirm", !isValid.data);
        }
      });
    },
    resetModal() {
      this.confirmAddSupport.password = "";
    },
  },
};
</script>
